import React from 'react'
import { useAppSelector } from '../../app/hooks';

const ShowError = () => {
    const { timeEntriesList } = useAppSelector((state) => state.timesheet);
    const errorMessage = () => {
        let objErrorMessage = [] as any;
        if (timeEntriesList) {
            timeEntriesList
                .map(x => {
                    x.timeEntries
                        .filter((x: any) => x.ErrorMessage !== "")
                        .map((y: any) => {
                            objErrorMessage.push(y.ErrorMessage);
                        })
                });
            return objErrorMessage;
        }
        return [];
    }
    return (
        <>
            {errorMessage().length > 0 &&
                <div id="validationerror" className={"alert alert-danger"} style={{marginBottom:48}}>
                    <strong>Error!</strong>
                    <ul>
                        {errorMessage().map((msg: any, i: any) => {
                            return <li key={i}>{msg}</li>
                        }
                        )}
                    </ul>
                </div>
            }
        </>
    )
}

export default ShowError